import { Injectable, Pipe, PipeTransform } from "@angular/core";
@Pipe({
    name: "listItemTypeFilter",
    pure: false
})
@Injectable({
    providedIn: 'root'
})
export class ListItemTypeFilter implements PipeTransform {
    transform(items: any[]): any {
        if (!items)
            return [];
        return items.filter(f => f.shown);
    }
}
